<template>
	<div class="sky-input">
		<itemSearch v-bind="$attrs" v-on="$listeners">
			<el-input
				ref="input"
				:type="inputType"
				:value="selfData"
				:size="size"
				@change="change"
				@input="input"
				@blur="blur"
				v-bind="$attrs"
				:placeholder="placeholder"
				validate-event
				v-focus="focus"
			>
				<template v-if="scope && scope.vSlot" :slot="scope.vSlot">{{ scope.slotProp }}</template>
			</el-input>
		</itemSearch>
	</div>
</template>
<script>
import formStore from '@/mixins/formStore.js';
export default {
	name: 'sky-input',
	props: {
		toolContent: String,
		placeholder: {
			default: '',
		},
		inputType: {
			type: String,
			value: 'text',
		},
		size: String,
		scope: {
			type: Object,
		},
		focus: {
			type: Boolean,
			default: false,
		},
	},
	mixins: [formStore],
	data() {
		return {
			val: '',
		};
	},
	methods: {
		change(val) {
			this.selfData = val;
			!this.delay && this.setVal();
			this.$emit('change', val);
			this.scope && this.scope.change && this.scope.change(val);
		},
		input(val) {
			this.selfData = val;
		},
		blur() {
			this.$emit('blur');
		},
	},
	directives: {
		focus: {
			update(el, data) {
				// 重点注意这里 当前元素是div  所以要查到子元素中的input
				const dom = el.querySelector('input') || el.querySelector('textarea');
				if (data.value) dom.focus();
			},
		},
	},
};
</script>
<style scoped lang="scss"></style>
